import { findAll, uploadFile, downloadFile, downloadAndOpenFile, remove } from '../services/Service';
import { Documento } from '../types/Documento';

export const useDocumentoPersonalHabilitacion = () => {
    const BASE_URL = 'doc-personal-habcontratista';

    const buscarDocumentosByPersonal = (idPersonal: number) =>
        findAll(`${BASE_URL}/personal-habilitacion/${idPersonal}`);

    const subirDocumento = (file: File, params: any) =>
        uploadFile(`${BASE_URL}/subirArchivo`, file, params, false);

    const visualizarDocumento = <T extends Documento>(doc: T) =>
        downloadAndOpenFile(`${BASE_URL}/visualizarArchivo`, doc);

    const descargarDocumento = <T extends Documento>(doc: T) =>
        downloadFile(`${BASE_URL}/descargarArchivo`, doc);

    const eliminarDocumento = (id: number) =>
        remove(BASE_URL, String(id));

    return {
        buscarDocumentosByPersonal,
        subirDocumento,
        visualizarDocumento,
        descargarDocumento,
        eliminarDocumento,
    };
};
